export default {"src":"/_next/static/media/person-alt.17920ce0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};